import { useRef, useEffect, useState, useContext } from "react";

import classes from "./LoginForm.module.scss";
import { UserIcon, LockClosedIcon } from "./Icons";
import ValidUserContext from "../authCheck";


let isInitial = true;

function LoginForm() {
  const validUserContext = useContext(ValidUserContext);
  const [disclaimerAcknowledged, setDisclaimerAcknowledged] = useState(true);


  const emailInputRef = useRef();
  const passwordInputRef = useRef();


  useEffect(() => {
    if (isInitial) {
      validUserContext.localAuthCheck(true);
      isInitial = false;
    }
  }, [validUserContext]);

  const submitHandler = (event) => {
    event.preventDefault();

    validUserContext.apiAuthCheck(
      emailInputRef.current.value,
      passwordInputRef.current.value,
      false
    );
  };
  

  return (
    <div className={classes.logincontainer}>
      <form onSubmit={submitHandler} className={classes.form}>
        <div className={classes.loginInstructions}>Welcome back</div>
        <div className={classes.loginSubtitle}>
          Please enter your email/password below.
        </div>

        <label className={classes.field}>
          <UserIcon className={classes.fieldIcon} />
          <input
            className={classes.input}
            type="email"
            id="user-name"
            name="user-name"
            autoComplete="on"
            placeholder="Email"
            ref={emailInputRef}
            required={!validUserContext.isLoggedIn}
          />
        </label>

        <label className={classes.field}>
          <LockClosedIcon className={classes.fieldIcon} />
          <input
            className={classes.input}
            type="password"
            id="user-password"
            name="user-password"
            autoComplete="off"
            placeholder="Password"
            ref={passwordInputRef}
            required={!validUserContext.isLoggedIn}
          />
        </label>

        <button
          className={`${disclaimerAcknowledged && !validUserContext.isLoggingIn ? classes.loginBtn : classes.loginBtnDisabled}`}
          disabled={
            validUserContext.isLoggedIn ||
            !disclaimerAcknowledged ||
            validUserContext.isLoggingIn
          }
        >
          {validUserContext.isLoggedIn
            ? "Already logged in"
            : validUserContext.loginStatus === "sending_code"
              ? "Sending code…"
              : validUserContext.isLoggingIn
                ? "Signing in…"
                : "Sign In"}
        </button>

        <button
          type="button"
          className={classes.linkBtn}
          onClick={validUserContext.forgotPassword}
          disabled={validUserContext.isLoggingIn}
        >
          Forgot password?
        </button>
      </form>
    </div>
  );
}

export default LoginForm;
